export const name = 'Mitchell Simoens'
export const picture = '/assets/blog/authors/Mitchell Simoens.png'
export const email = 'mitchellsimoens@gmail.com'
export const twitter = 'LikelyMitch'
export const linkedIn = 'mitchellsimoens'
export const shortBio = `Written by Mitchell Simoens who is a long time nerd developing software and building computers and gadgets. Anything expressed on this website are Mitchell Simoens's alone and do not represent his employer.`
